import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "launcher",
    "overlay",
    "panel",
    "screen",
    "answerQuestion",
    "answerBlock",
    "bodyInput",
    "confirmBody",
    "submitButton",
    "error",
  ]

  connect() {
    this._onKeydown = (event) => {
      if (event.key === "Escape") this.close()
    }
  }

  disconnect() {
    window.removeEventListener("keydown", this._onKeydown)
    document.body.classList.remove("is-qa-navigation-open")
  }

  open() {
    this.panelTarget.hidden = false
    this.overlayTarget.classList.add("is-open")
    this.launcherTarget.classList.add("is-hidden")
    document.body.classList.add("is-qa-navigation-open")
    window.addEventListener("keydown", this._onKeydown)
    this.showScreen("menu")
  }

  close() {
    this.panelTarget.hidden = true
    this.overlayTarget.classList.remove("is-open")
    this.launcherTarget.classList.remove("is-hidden")
    document.body.classList.remove("is-qa-navigation-open")
    window.removeEventListener("keydown", this._onKeydown)
    this.reset()
  }

  showMenu() {
    this.showScreen("menu")
  }

  showAnswer(event) {
    const index = event.params.index
    const question = event.currentTarget.textContent.trim()

    if (this.hasAnswerQuestionTarget) {
      this.answerQuestionTarget.textContent = question
    }

    this.answerBlockTargets.forEach((block) => {
      block.hidden = block.dataset.qaNavigationAnswerIndex !== String(index)
    })

    this.showScreen("answer")
  }

  showFormInput() {
    this.showScreen("form-input")
  }

  showFormConfirm() {
    const body = this.bodyInputTarget.value.trim()

    if (body === "") {
      this.showError("お問い合わせ内容を入力してください。")
      this.bodyInputTarget.focus()
      return
    }

    this.hideError()
    this.confirmBodyTarget.textContent = body
    this.showScreen("form-confirm")
  }

  submit() {
    const body = this.bodyInputTarget.value.trim()
    if (body === "") return

    this.submitButtonTarget.disabled = true

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    fetch("/mypage/inquiries", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-CSRF-Token": csrfToken,
      },
      body: JSON.stringify({ member_inquiry: { body: body } }),
      credentials: "same-origin",
    })
      .then((response) => {
        if (!response.ok) throw new Error("Failed to submit inquiry")
        this.showScreen("form-complete")
      })
      .catch((error) => {
        console.error(error)
        this.submitButtonTarget.disabled = false
        this.showFormInput()
        this.showError("送信に失敗しました。時間をおいて再度お試しください。")
      })
  }

  reset() {
    this.bodyInputTarget.value = ""
    this.confirmBodyTarget.textContent = ""
    this.submitButtonTarget.disabled = false
    this.hideError()
  }

  showScreen(name) {
    this.screenTargets.forEach((screen) => {
      screen.hidden = screen.dataset.qaNavigationScreen !== name
    })
    this.panelTarget.scrollTop = 0
  }

  showError(message) {
    if (!this.hasErrorTarget) return
    this.errorTarget.textContent = message
    this.errorTarget.hidden = false
  }

  hideError() {
    if (!this.hasErrorTarget) return
    this.errorTarget.textContent = ""
    this.errorTarget.hidden = true
  }
}
